import React from 'react';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

import { Header as BaseHeader } from '@common/components/Header';
import { Search } from "@common/components/Search";
import { getAppConfig } from "@common/utils/config";
import { getTestAttributes } from "@common/utils/tests";
import { Flex } from '@common/components/Flex';
import { Button } from '@common/components/Button';
import { MODULE_NAME } from '@modules/pedigrees/constants/shared';

import './header.styles.scss';

export type HeaderProps = {
  pedigreesSearchKeyword: string;
  className?: string;
  onNewPedigreeClick: () => void;
  onImportPedigreeClick: () => void;
  onFiltersChange: (params: { searchKeyword: string }) => void;
};

export const Header: React.FC<HeaderProps> = (props) => {
  const { className, pedigreesSearchKeyword, onFiltersChange, onNewPedigreeClick, onImportPedigreeClick } = props;

  const pedigreesConfig = getAppConfig().pedigrees || {};

  const handleFilterChange = React.useCallback((value: { searchKeyword: string }) => {
    onFiltersChange({ ...value });
  }, [onFiltersChange]);

  return (
    <BaseHeader 
      moduleName={I18n.t('Pedigrees')}
      className={cx('PedigreesHeader', className)}
    >
      <Search
        {...getTestAttributes({ id: "ped-home-tab-act-search-panel-tx-search" })}
        value={pedigreesSearchKeyword}
        withLiveSearch={pedigreesConfig.liveSearchEnabled}
        liveSearchDelay={pedigreesConfig.liveSearchDelay}
        onSearch={handleFilterChange}
      />
      <Flex>
        <Button
          {...getTestAttributes(MODULE_NAME, 'import-pedigree', 'button')}
          className="PedigreesHeader__import-pedigree-btn"
          onClick={onImportPedigreeClick}
        >
          {I18n.t('Import Pedigree')}
        </Button>
        <Button
          {...getTestAttributes(MODULE_NAME, 'new-pedigree', 'button')}
          bsStyle="primary"
          onClick={onNewPedigreeClick}
        >
          <i className="fa fa-plus"></i>
          {I18n.t('New Pedigree')}
        </Button>
      </Flex>
    </BaseHeader>
  );
};